"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _components = require("../../components");
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CreateDropdown = ({
  languageSelected,
  languagesList,
  onChange
}) => {
  return /*#__PURE__*/_react.default.createElement(_reactstrap.UncontrolledDropdown, {
    className: "d-inline-block"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
    className: "nav-link",
    caret: true,
    color: "link"
  }, !Object.keys(languageSelected).length ? "Select" : languageSelected.DisplayName), languagesList && /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, null, languagesList.map((val, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
      key: index,
      onClick: () => onChange(val),
      active: languageSelected !== {} && val.DisplayName === languageSelected.DisplayName
    }, val.DisplayName);
  })));
};
class TranslateTableColumnHeader extends _react.default.Component {
  constructor(props) {
    super(props);
    this.sortColumn = null;
    this.sortOrder = null;
    this.sortIndex = null;
    this.state = {
      languageFrom: this.props.languageFrom,
      languageTo: this.props.languageTo,
      languages: this.props.languages
    };
  }
  render() {
    const {
      column,
      onSort,
      sortBy,
      handleSelectLanguageFrom,
      handleSelectLanguageTo,
      languages,
      languageFrom,
      languageTo,
      translationsArray
    } = this.props;
    if (this.state.length === 0) return /*#__PURE__*/_react.default.createElement(_components.Spinner, null);
    for (let i = 0; i < sortBy.length; i++) {
      if (sortBy[i].column === column.key) {
        this.sortColumn = sortBy[i].column;
        this.sortOrder = sortBy[i].order;
        this.sortIndex = i;
      }
    }
    if (column.headerType && column.headerType === "Dropdown") {
      if (column.displayName === "From ") {
        return /*#__PURE__*/_react.default.createElement("th", {
          scope: "col",
          className: "table-header align-middle",
          style: {
            minWidth: "20rem"
          }
        }, column.displayName, /*#__PURE__*/_react.default.createElement(CreateDropdown, {
          languageSelected: languageFrom,
          languagesList: languages.filter(item => item !== languageTo),
          onChange: handleSelectLanguageFrom
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("th", {
          scope: "col",
          className: "table-header align-middle",
          style: {
            minWidth: "20rem"
          }
        }, column.displayName, Object.entries(translationsArray).length !== 0 && /*#__PURE__*/_react.default.createElement(CreateDropdown, {
          languageSelected: languageTo,
          languagesList: languages.filter(item => item !== languageFrom),
          onChange: handleSelectLanguageTo
        }));
      }
    }
    return !column.sortable ? /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "table-header align-middle"
    }, column.displayName) : /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "table-header align-middle",
      onClick: () => onSort(),
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, column.displayName), this.sortColumn ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons ml-1"
    }, sortBy.length ? this.sortOrder === "DESC" ? /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "expand_more",
      size: 16
    }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "expand_less",
      size: 16
    }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "unfold_more",
      size: 16
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "badge badge-pill badge-primary ml-1"
    }, this.sortIndex + 1)) : /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons ml-1"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "unfold_more",
      size: 16
    })));
  }
}
var _default = exports.default = TranslateTableColumnHeader;
module.exports = exports.default;